
// Global listener: Disable mouse scroll and Up/Down arrow key increment/decrement on number inputs
if (typeof window !== 'undefined') {
  document.addEventListener('wheel', function(e) {
    if (document.activeElement && document.activeElement.type === 'number') {
      document.activeElement.blur();
    }
  }, { passive: true });

  document.addEventListener('keydown', function(e) {
    if (document.activeElement && document.activeElement.type === 'number') {
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        e.preventDefault();
      }
    }
  });
}

import { HashRouter, Route, Routes } from "react-router-dom"
import UserRouter from "./Routes/UserRouter"


function App() {

  return (
    <>
      <HashRouter>
        <Routes>
          <Route path="/*" element={<UserRouter />} />
        </Routes>
      </HashRouter>
    </>
  )
}

export default App
